package meineglasfaser.frontend.admin.pages.workflow

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import meineglasfaser.api.Workflow
import meineglasfaser.api.YaTableOptions
import meineglasfaser.api.routes.AdminRoutes
import meineglasfaser.frontend.admin.components.widgets.YaTable
import meineglasfaser.frontend.admin.components.widgets.named
import meineglasfaser.frontend.common.BackendApi
import meineglasfaser.frontend.common.setJsonBody
import meineglasfaser.frontend.common.withAuth
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.Text

@Page
@Composable
fun WorkflowListPage(ctx: PageContext) {
    YaTable(
        header = { H1 { Text("Workflow") } },
        idProperty = Workflow::id,
        columns = listOf(
            Workflow::id named "ID",
            Workflow::kind named "Kategorie",
            Workflow::status named "Status",
            Workflow::title named "Titel",
        ),
        initialOptions = YaTableOptions.DEFAULT,
        fetch = { options ->
            BackendApi.post(AdminRoutes.Workflows()) {
                withAuth()
                setJsonBody(options)
            }
        }
    )
}
